module.exports = __webpack_public_path__ + "static/media/popcorn-fail-new.20d3461e.png";